import { Switch, Route, Redirect } from 'react-router-dom';
import Landing from 'pages/Landing';
import Profile from 'pages/Profile';
import Login from 'pages/Login';
import Register from 'pages/Register';
import Dreamquran from 'pages/mobile/Dreamquran';
import StorageExplorer from 'pages/mobile/StorageExplorer';
import HadistArbain from "./pages/mobile/HadistArbain";
import DreamJoystick from "./pages/mobile/DreamJoystick";
import MasjidTv from "./pages/mobile/MasjidTv";

// Font Awesome Style Sheet
import '@fortawesome/fontawesome-free/css/all.min.css';

// Tailwind CSS Style Sheet
import 'assets/styles/tailwind.css';

function App() {
    return (
        <Switch>
            <Route exact path="/" component={Landing} />
            <Route exact path="/profile" component={Profile} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/mobile/dreamquran" component={Dreamquran} />
            <Route exact path="/mobile/object-storage-explorer" component={StorageExplorer} />
            <Route exact path="/mobile/hadist-arbain" component={HadistArbain} />
            <Route exact path="/mobile/dreamjoystick" component={DreamJoystick} />
            <Route exact path="/mobile/masjid-tv" component={MasjidTv} />
            <Redirect from="*" to="/" />
        </Switch>
    );
}

export default App;
